var map = {
	"./arabic.json": "aa6a",
	"./chinese.json": "9831",
	"./chinesetr.json": "c199",
	"./dutch.json": "9237",
	"./english.json": "6f35",
	"./french.json": "89472",
	"./german.json": "de53",
	"./gujarati.json": "d80f",
	"./hebrew.json": "f7d0",
	"./hindi2.json": "e27a",
	"./indonesian.json": "32a5",
	"./italian.json": "b25d",
	"./japanese.json": "8420",
	"./kannada.json": "5364",
	"./korean.json": "410a",
	"./marathi.json": "4294",
	"./polish.json": "004d",
	"./portuguese.json": "4da9",
	"./romanian.json": "0162",
	"./russian.json": "9185",
	"./spanish.json": "443f",
	"./swedish.json": "36b6",
	"./tamil.json": "c61e",
	"./telugu.json": "cb09",
	"./thai.json": "955a",
	"./turkish.json": "073e",
	"./ukrainian.json": "332f",
	"./vietnamese.json": "6091"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";